import { useEffect } from 'react';

/**
 * Calls `onEscape` when the user presses the Escape key, while `enabled` is true (default true).
 * Standard modal-dismiss helper so any popup can be closed with Esc. Always call it unconditionally
 * (Rules of Hooks) and gate with `enabled` when the dialog is conditionally shown.
 */
export function useEscapeKey(onEscape: () => void, enabled = true): void {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { e.stopPropagation(); onEscape(); }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onEscape, enabled]);
}
